import React, { lazy } from 'react';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import { RouterProvider } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Login from './Shared/Components/Login';
import Loading from './Shared/Components/Loading';

import AppRoutes from './Shared/Routes/AppRoutes';

const AdministrationPage = lazy(() => import('./Modules/Administration/AdministrationPage'));
const Nav = lazy(() => import('./Shared/Components/Nav'));
const WorkspacePage = lazy(() => import('./Modules/Workspace/WorkspacePage'));
const workspaceStore = lazy(() => import('./Modules/Workspace/workspaceStore'));

const pages = [
  {id: 1, displayName: "Chat", key: "interact", component: <Provider store={workspaceStore}><WorkspacePage /></Provider>, route: "/"},
  {id: 2, displayName: "Workspaces", key: "dashboard", component: <body>dashboard</body>, route: "workspaces"},
  {id: 4, displayName: "Administration", key: "admin", component: <AdministrationPage />, route: "administration"},
]

const App = () => {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();

  const theme = useTheme();
  return (
    <CssBaseline>
      {!isLoading ?
        isAuthenticated ?
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3, p: 3, overflow: 'visible', height: '100vh', width: '100vw' }}>
              <Nav navList={pages}/>
              <Box component="main" sx={{ flexGrow: 1, overflow: 'visible' }}>
                <RouterProvider router={AppRoutes}/>
              </Box>
          </Box>
        : <Login />
      : <Loading />}
    </CssBaseline>
  );
}

export default App;
